import { Component, effect, input, signal } from '@angular/core';
import { ButtonModule } from '@openng/optimus-ui/button';
import { GalleriaModule } from '@openng/optimus-ui/galleria';
import { ProgressSpinner } from '@openng/optimus-ui/progressspinner';

@Component({
  selector: 'lib-img-viewer',
  standalone: true,
  imports: [GalleriaModule, ProgressSpinner, ButtonModule],
  templateUrl: './img-viewer.component.html',
  styleUrl: './img-viewer.component.scss'
})
export class ImgViewerComponent {
  src = input.required<string>();
  height = input<string>('100%');

  isLoaded = signal<boolean>(false);
  hasError = signal<boolean>(false);

  protected retryCount = signal(0);

  constructor() {
    effect(() => {
      this.src();
      this.isLoaded.set(false);
      this.hasError.set(false);
      this.retryCount.set(0);
    });
  }

  onImageError(): void {
    this.isLoaded.set(true);
    this.hasError.set(true);
  }

  retry(): void {
    this.hasError.set(false);
    this.isLoaded.set(false);
    this.retryCount.update(count => count + 1);
  }
}
